export default "__VITE_PUBLIC_ASSET__6a12810d__"